import { render, staticRenderFns } from "./MenuSpacer.vue?vue&type=template&id=142e3bca&scoped=true&"
var script = {}
import style0 from "./MenuSpacer.vue?vue&type=style&index=0&id=142e3bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e3bca",
  null
  
)

export default component.exports